import React, { useMemo } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { findVillageById, villageLabel } from '../../data/master/villages';
import { AppSelect } from './AppSelect';

/**
 * Village picker — searchable scrollable dropdown (not native select).
 * Selecting a village auto-fills address fields from Village Master via onChange(villageId, village).
 */
export function VillageSelect({
  label = 'Village / Town / City',
  villages,
  value,
  onChange,
  isRequired,
  helperText = 'From Village Master — PIN prefilled on select.',
  isInvalid,
  errorMessage,
  showSummary = false,
}) {
  const selected = findVillageById(villages, value);

  const options = useMemo(
    () =>
      villages.map((v) => ({
        value: v.villageId,
        label: v.villageName,
        description: `${v.talukaName} · ${v.pin} · ${v.villageId}`,
        village: v,
      })),
    [villages],
  );

  return (
    <Box>
      <AppSelect
        label={label}
        isRequired={isRequired}
        isSearchable
        searchPlaceholder="Search village / PIN / ID…"
        placeholder="Select village"
        options={options}
        value={value || ''}
        onChange={(villageId, option) =>
          onChange?.(villageId, option?.village || findVillageById(villages, villageId))
        }
        helperText={isInvalid ? undefined : helperText}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
      />
      {showSummary && selected ? (
        <Box
          mt={2}
          p={3}
          bg="bg.input"
          borderRadius="sm"
          borderWidth="1px"
          borderColor="border.subtle"
        >
          <Text fontSize="12px" color="text.secondary" mb={1}>
            From Village Master
          </Text>
          <Text fontSize="13px" color="text.primary">
            {selected.talukaName} · {selected.district} · {selected.state} · {selected.country}
          </Text>
          <Text fontSize="13px" color="text.secondary">
            PIN {selected.pin} · {villageLabel(selected)}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}
